import { ProductUIInfoFuse } from '@/store/modules/product';
import FileSaver from 'file-saver';
import { Component, Vue } from 'vue-property-decorator';

const jsonexport = require('jsonexport/dist');

@Component
export default class DownloadXLSMixin extends Vue {
    public downloadXLS(data: ProductUIInfoFuse[]) {
        const options = {
            orderHeaders: false,
            verticalOutput: false,
            rowDelimiter: '\t',
            headerPathString: ' ',
        };
        jsonexport(data, options, (err: any, res: any) => {
            if (err) return console.error(err);
            const blob = new Blob([res], { type: 'text/plain;charset=utf-8' });
            // write string to file
            // save file
            FileSaver.saveAs(blob, 'myxls.xlsx');
        });
    }
}
